<div class="help-layout">
  

  <!--<div class="accordion-layout box-shadow">
    <p-accordion [activeIndex]="accordionIndex">
      <p-accordionTab *ngFor="let question of supportQuestions"
                      header="{{question.title}}" class="accordion-tab">
        <div [innerHTML]="question.content"></div>
      </p-accordionTab>
    </p-accordion>
  </div>-->
  <div><h1>welcome to the Help section</h1></div>
    <h2>please use the icon in the bottom right corner.</h2>

     
 

</div>
